import React, { useEffect, useMemo, useState } from "react";
import { SectionTitleComponent } from "../components/section-title.component";
import { GalleryImageComponent } from "./components/gallery-image.component";
import { section } from "./components/gallery-data";

interface IImageGalleryContainerComponentProps { }

export const ImageGalleryContainerComponent: React.FC<
    IImageGalleryContainerComponentProps
> = () => {
    const [activeCategory, setActiveCategory] = useState("All");
    const [fullScreenImage, setFullScreenImage] = useState<string | null>(null);

    // Preload all image URLs on mount
    useEffect(() => {
        section.images.forEach((image) => {
            const img = new Image();
            img.src = image.url;
        });
    }, []);

    // Memoize filtered images
    const filteredImages = useMemo(() => {
        return section.images.filter(
            (img) => activeCategory === "All" || img.category === activeCategory
        );
    }, [activeCategory]);

    return (
        <section id="gallery" className="portfolio section">
            <SectionTitleComponent
                title={section.title}
                subTitle={section.subTitle}
            />

            <div className="container">
                <div
                    className="isotope-layout"
                    data-default-filter="*"
                    data-layout="masonry"
                    data-sort="original-order"
                >
                    <ul
                        className="portfolio-filters isotope-filters pp"
                        data-aos="fade-up"
                        data-aos-delay="100"
                    >
                        {section.categories.map((category) => (
                            <li
                                key={category}
                                className={
                                    activeCategory === category ? "filter-active gradient-bg" : ""
                                }
                                onClick={() => setActiveCategory(category)}
                            >
                                {category}
                            </li>
                        ))}
                    </ul>

                    <div
                        className="row gy-4 isotope-container"
                        data-aos="fade-up"
                        data-aos-delay="200"
                    >
                        {filteredImages.map((image, index) => (
                            <GalleryImageComponent
                                key={`${image.name}-${index}`}
                                {...image}
                                onClick={() => setFullScreenImage(image.url)}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {fullScreenImage && (
                <div
                    className="fullscreen-overlay"
                    onClick={() => setFullScreenImage(null)}
                >
                    <button
                        className="close-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            setFullScreenImage(null);
                        }}
                    >
                        ✕
                    </button>
                    <img loading="lazy" src={fullScreenImage} alt="Full Screen" />
                </div>
            )}
        </section>
    );
};
